<template>
	<section class="view-settings-overlay">
		<section class="tabs">
			<ul>
				<li>Tab 1</li>
				<li>Tab 2</li>
				<li>Tab 3</li>
			</ul>
		</section>

		<section class="content">Contnet goes here</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Settings
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewSettingsOverlay extends ViewBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.view-settings-overlay {
		// Not implemented
	}
</style>
